import { render } from "./DetalheTransferenciaMrp.vue?vue&type=template&id=b144be3a&scoped=true"
import script from "./DetalheTransferenciaMrp.vue?vue&type=script&lang=js"
export * from "./DetalheTransferenciaMrp.vue?vue&type=script&lang=js"

import "./DetalheTransferenciaMrp.vue?vue&type=style&index=0&id=b144be3a&scoped=true&lang=css"
import "./DetalheTransferenciaMrp.vue?vue&type=style&index=1&id=b144be3a&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b144be3a"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QPagination from 'quasar/src/components/pagination/QPagination.js';
import QRadio from 'quasar/src/components/radio/QRadio.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QIcon,QInput,QSelect,QBtn,QToggle,QTable,QImg,QTd,QPagination,QRadio,QDialog,QCard,QCardSection,QCardActions,QSeparator});qInstall(script, 'directives', {ClosePopup});
